import { render, staticRenderFns } from "./FormTriangle.vue?vue&type=template&id=73a6b798&scoped=true&"
import script from "./FormTriangle.vue?vue&type=script&lang=js&"
export * from "./FormTriangle.vue?vue&type=script&lang=js&"
import style0 from "./FormTriangle.vue?vue&type=style&index=0&id=73a6b798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6b798",
  null
  
)

export default component.exports